var map = {
	"./01_hero_desktop.jpg": 608,
	"./01_hero_mobile.jpg": 609,
	"./01_hero_tablet.jpg": 610,
	"./01_twitter_image.jpg": 611,
	"./02_hero_desktop.jpg": 612,
	"./02_hero_mobile.jpg": 613,
	"./02_hero_tablet.jpg": 614,
	"./02_twitter_image.jpg": 615,
	"./03_hero_desktop.jpg": 616,
	"./03_hero_mobile.jpg": 617,
	"./03_hero_tablet.jpg": 618,
	"./03_twitter_image.jpg": 619,
	"./04_hero_desktop.jpg": 620,
	"./04_twitter_image.jpg": 621,
	"./05_hero_desktop.jpg": 622,
	"./05_twitter_image.jpg": 623,
	"./06_hero_desktop.jpg": 624,
	"./06_twitter_image.jpg": 625,
	"./07_hero_desktop.jpg": 626,
	"./07_twitter_image.jpg": 627,
	"./08_hero_desktop.jpg": 628,
	"./08_twitter_image.jpg": 629,
	"./09_hero_desktop.jpg": 630,
	"./09_twitter_image.jpg": 631,
	"./10_hero_desktop.jpg": 632,
	"./10_twitter_image.jpg": 633,
	"./11_hero_desktop.jpg": 634,
	"./11_twitter_image.jpg": 635,
	"./12_the-urban-farm-sending-meals-to-children.jpg": 636,
	"./12_the-urban-farm-sending-meals-to-children_twitter_image.jpg": 637,
	"./22_hero_desktop.jpg": 638,
	"./22_twitter_image.jpg": 639,
	"./2ATH3BK.crop-twitter.jpg": 640,
	"./2ATH3BK.crop.jpg": 641,
	"./ABENT3.crop-twitter.jpg": 642,
	"./ABENT3.crop.jpg": 643,
	"./James-wong-hero.jpg": 644,
	"./James-wong-twitter.jpg": 645,
	"./LNC-aggregates-on-sand-2-crop.jpg": 646,
	"./Seawatergreenhouseaus_crop.jpg": 647,
	"./Seawatergreenhouseaus_crop_twitter.jpg": 648,
	"./Thought-leaders-hero.jpg": 649,
	"./Thought-leaders-twitter.jpg": 650,
	"./africa_getty.jpg": 651,
	"./africa_getty_twitter.jpg": 652,
	"./cattle-drones-twitter.jpg": 653,
	"./cattle-drones_hero.jpg": 654,
	"./food-chain_hero_desktop.jpg": 655,
	"./food_chain_twitter_image.jpg": 656,
	"./how-covid-19-is-changing-food-shopping-twitter-image.jpg": 657,
	"./how-covid-19-is-changing-food-shopping.jpg": 658,
	"./how-we-can-adapt-plants-to-save-our-planet-hero.jpg": 659,
	"./how-we-can-adapt-plants-to-save-our-planet-twitter.jpg": 660,
	"./kiwi-picker-robotics-twitter.jpg": 661,
	"./kiwi-picker-robotics.jpg": 662,
	"./the-freedom-soup-twitter.jpg": 663,
	"./the-freedom-soup.jpg": 664,
	"./the-green-milk-made-from-cells-twitter.jpg": 665,
	"./the-green-milk-made-from-cells.jpg": 666,
	"./the-massive-farms-emerging-beneath-our-cities.jpg": 667,
	"./the-massive-farms-emerging-beneath-our-cities_twitter_image.jpg": 668,
	"./the-simple-shellfish-that-fights-climate-change_hero.jpg": 669,
	"./the-simple-shellfish-that-fights-climate-change_twitter.jpg": 670,
	"./the_invisible_women_article.jpg": 671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 319;